module.exports = __webpack_public_path__ + "static/media/s-l500.56d12be0.jpg";